import React from 'react';
import Image from '../image';
import TextWithHighlights from './text-with-highlights';
import SearchRow from './search-row';
import style from './index.module.scss';
import { isPageHit } from './types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SearchResult = ({
  href,
  hit,
  index,
  hitKind,
  imageUrl,
  highlightField,
  secondaryHighlightedContent,
  description,
  noImage = false,
  className,
  onClick,
  isTextBold = true,
  imageBgSize = 'cover'
}) => /*#__PURE__*/_jsxs(SearchRow, {
  href: href,
  hitKind: hitKind,
  className: className,
  target: isPageHit(hit) && hit.isNewTab ? '_blank' : '_self',
  hit: hit,
  index: index,
  onClick: onClick,
  children: [!noImage && /*#__PURE__*/_jsx(Image, {
    className: style.searchImage,
    imageUrl: imageUrl,
    ratio: "square",
    bgSize: imageBgSize
  }), /*#__PURE__*/_jsx(TextWithHighlights, {
    hit: hit,
    field: highlightField,
    isTextBold: isTextBold
  }), secondaryHighlightedContent && /*#__PURE__*/_jsx("div", {
    className: style.textWithHighlights,
    children: secondaryHighlightedContent
  }), description && /*#__PURE__*/_jsx("div", {
    className: style.description,
    children: description
  })]
}, hit.objectID);

export default SearchResult;